export const categoryTypes = {
  MY_ID_CONFIRMATION_SAME_PW: "My Id Confirmation MMS",
  MY_ID_CONFIRMATION_DIFF_PW: "My Id Confirmation MMD",
  FORGOTTEN_PASSWORD: "Forgotten password",
  RESET_PASSWORD: "Reset password",
  MFA: "MFA",
  FORGOTTEN_PASSWORD_OTP: "Forgotten password OTP",
  ACCOUNT_RECOVERY: "Account Recovery",
  ACCOUNT_RECOVERY_OTP: "Account Recovery OTP",
  ACCOUNT_RECOVERY_RESET_PASSWORD: "Account Recovery Reset Password",
  REGISTRATION: "Registration",
  PROGRESSIVE_REGISTRATION: "Progressive registration",
  LOGIN: "Login",
  WEB_AUTHN: "WebAuthn",
};

export const actionTypes = {
  CLICK: "Click",
  SUCCESS: "Success",
  ERROR: "Error",
  CODE_REQUESTED: "Code requested",
  SUBMIT: "Submit",
  AUTO_SEND_SKIPPED: "Auto send skipped",
};
